import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function AboutPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="about" />

      {/* ===== HERO ===== */}
      <PageHero className="pageHero">
        <div className="container flexSpaceCenter">
          <HeroText className="hero-in">
            <PageTag className="pinkBg whiteColor radius6">אישי</PageTag>
            <h1 className="font60 extraBold darkColor heroTitle" style={{ marginTop: "15px", lineHeight: "1.1" }}>
              הסיפור שלי ✨
            </h1>
            <p className="font18 darkColor" style={{ marginTop: "20px", lineHeight: "1.7", maxWidth: "500px" }}>
              {/* TEXT PLACEHOLDER — replace with your tagline */}
              כאן תוכלי לכתוב משפט קצר שמייצג אותך.
              מה מניע אותך, מה הלב שלך.
            </p>
          </HeroText>
          <HeroImageBox>
            {/* IMAGE PLACEHOLDER — your main personal photo */}
            <HeroImgPlaceholder className="radius8">
              <span>📸 תמונה אישית: גיבור</span>
            </HeroImgPlaceholder>
          </HeroImageBox>
        </div>
      </PageHero>

      {/* ===== MAIN STORY ===== */}
      <Section className="lightBg">
        <div className="container">
          <TwoCol>
            <ImageSide>
              <MainImgBox>
                {/* IMAGE PLACEHOLDER — main personal photo */}
                <MainImgPlaceholder className="radius8">
                  <span>📸 התמונה שלי</span>
                </MainImgPlaceholder>
                <FloatingImg className="radius8">
                  {/* IMAGE PLACEHOLDER — second personal/work photo */}
                  <span>📸 תמונה נוספת</span>
                </FloatingImg>
              </MainImgBox>
            </ImageSide>
            <TextSide>
              <p className="font15 semiBold" style={{ color: "var(--rose-600)" }}>קצת עליי</p>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                מי אני?
              </h2>
              {/* TEXT PLACEHOLDER — replace with your real personal story */}
              <BodyText className="font15">
                כאן תוכלי לכתוב את הסיפור שלך: מי את, מה מניע אותך,
                למה את עושה את מה שאת עושה.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                שתפי את הדרך שלך ואת הלב שמאחורי הכלים האלה.
                זה המקום שבו הקוראות מתחברות אלייך כאדם.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                {/* TEXT PLACEHOLDER */}
                הוסיפי כאן פסקה נוספת על הרקע שלך, ההכשרה, או מה הוביל אותך
                לעולם של כלים יצירתיים ועבודה עצמית.
              </BodyText>
              <SmallImgRow>
                {/* IMAGE PLACEHOLDER — small decorative or work photos */}
                <MiniImg className="radius6" style={{ background: "var(--tint-rose)" }}>
                  <span>📸 פרט 1</span>
                </MiniImg>
                <MiniImg className="radius6" style={{ background: "var(--tint-butter)" }}>
                  <span>📸 פרט 2</span>
                </MiniImg>
                <MiniImg className="radius6" style={{ background: "var(--tint-rose)" }}>
                  <span>📸 פרט 3</span>
                </MiniImg>
              </SmallImgRow>
            </TextSide>
          </TwoCol>
        </div>
      </Section>

      {/* ===== JOURNEY / TIMELINE ===== */}
      <Section>
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">המסע שלי 🌱</h2>
            <p className="font15 greyColor">כמה תחנות חשובות בדרך</p>
          </SectionHeader>
          <JourneyGrid className="stagger-reveal">
            <JourneyCard className="lightBg radius8">
              {/* IMAGE PLACEHOLDER — photo from this period/milestone */}
              <JourneyImg style={{ background: "var(--tint-rose)" }}>
                <span>📸 תמונה: תחנה 1</span>
              </JourneyImg>
              <JourneyCardBody>
                <JourneyYear className="pinkBg whiteColor radius6">שנת ____</JourneyYear>
                <h3 className="font20 extraBold darkColor" style={{ margin: "12px 0 8px" }}>
                  {/* TEXT PLACEHOLDER */}
                  כותרת תחנה ראשונה
                </h3>
                <p className="font14" style={{ lineHeight: "1.7", color: "var(--ink-soft)" }}>
                  {/* TEXT PLACEHOLDER */}
                  תיאור קצר של מה שקרה, מה למדת, מה השתנה.
                </p>
              </JourneyCardBody>
            </JourneyCard>

            <JourneyCard className="lightBg radius8">
              <JourneyImg style={{ background: "var(--tint-butter)" }}>
                <span>📸 תמונה: תחנה 2</span>
              </JourneyImg>
              <JourneyCardBody>
                <JourneyYear className="pinkBg whiteColor radius6">שנת ____</JourneyYear>
                <h3 className="font20 extraBold darkColor" style={{ margin: "12px 0 8px" }}>
                  כותרת תחנה שנייה
                </h3>
                <p className="font14" style={{ lineHeight: "1.7", color: "var(--ink-soft)" }}>
                  תיאור קצר של מה שקרה, מה למדת, מה השתנה.
                </p>
              </JourneyCardBody>
            </JourneyCard>

            <JourneyCard className="lightBg radius8">
              <JourneyImg style={{ background: "var(--tint-rose)" }}>
                <span>📸 תמונה: תחנה 3</span>
              </JourneyImg>
              <JourneyCardBody>
                <JourneyYear className="pinkBg whiteColor radius6">שנת ____</JourneyYear>
                <h3 className="font20 extraBold darkColor" style={{ margin: "12px 0 8px" }}>
                  כותרת תחנה שלישית
                </h3>
                <p className="font14" style={{ lineHeight: "1.7", color: "var(--ink-soft)" }}>
                  תיאור קצר של מה שקרה, מה למדת, מה השתנה.
                </p>
              </JourneyCardBody>
            </JourneyCard>
          </JourneyGrid>
        </div>
      </Section>

      {/* ===== FULL WIDTH PHOTO ===== */}
      <FullWidthImg>
        {/* IMAGE PLACEHOLDER — wide atmospheric/lifestyle photo of you */}
        <FullWidthPlaceholder>
          <span>📸 תמונה רחבה: אווירה / סטודיו / סדנה</span>
        </FullWidthPlaceholder>
      </FullWidthImg>

      {/* ===== VALUES ===== */}
      <Section className="greenBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">מה מנחה אותי 💛</h2>
          </SectionHeader>
          <ValuesGrid className="stagger-reveal">
            <ValueItem>
              {/* IMAGE PLACEHOLDER */}
              <ValueImg className="radius8" style={{ background: "var(--tint-paper)" }}>
                <span>📸 ערך 1</span>
              </ValueImg>
              <h3 className="font20 extraBold darkColor" style={{ margin: "15px 0 8px" }}>
                {/* TEXT PLACEHOLDER */}
                ערך ראשון
              </h3>
              <p className="font14 darkColor" style={{ lineHeight: "1.7" }}>
                תיאור קצר של הערך: מה הוא אומר לך ואיך הוא מתבטא בעבודה שלך.
              </p>
            </ValueItem>
            <ValueItem>
              <ValueImg className="radius8" style={{ background: "var(--tint-rose)" }}>
                <span>📸 ערך 2</span>
              </ValueImg>
              <h3 className="font20 extraBold darkColor" style={{ margin: "15px 0 8px" }}>
                ערך שני
              </h3>
              <p className="font14 darkColor" style={{ lineHeight: "1.7" }}>
                תיאור קצר של הערך: מה הוא אומר לך ואיך הוא מתבטא בעבודה שלך.
              </p>
            </ValueItem>
            <ValueItem>
              <ValueImg className="radius8" style={{ background: "var(--tint-paper)" }}>
                <span>📸 ערך 3</span>
              </ValueImg>
              <h3 className="font20 extraBold darkColor" style={{ margin: "15px 0 8px" }}>
                ערך שלישי
              </h3>
              <p className="font14 darkColor" style={{ lineHeight: "1.7" }}>
                תיאור קצר של הערך: מה הוא אומר לך ואיך הוא מתבטא בעבודה שלך.
              </p>
            </ValueItem>
          </ValuesGrid>
        </div>
      </Section>

      {/* ===== PHOTO GALLERY ===== */}
      <Section className="lightBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">רגעים 📷</h2>
          </SectionHeader>
          <PhotoGrid>
            {[1,2,3,4,5,6].map((i) => (
              <PhotoItem key={i} className="radius8" style={{ background: i % 3 === 0 ? "var(--tint-butter)" : i % 3 === 1 ? "var(--tint-rose)" : "var(--tint-mauve)" }}>
                {/* IMAGE PLACEHOLDER — personal/work moments */}
                <span>📸 רגע {i}</span>
              </PhotoItem>
            ))}
          </PhotoGrid>
        </div>
      </Section>

      {/* ===== CTA ===== */}
      <CTASection className="pinkBg">
        <div className="container textCenter">
          <h2 className="font40 extraBold whiteColor">בואי נתחיל את המסע 💌</h2>
          <p className="font18 whiteColor" style={{ margin: "20px auto", maxWidth: "500px", lineHeight: "1.7" }}>
            רוצה לשמוע עוד? יש לך שאלה? שמחה מאוד לשמוע.
          </p>
          <CTABtns>
            <CTABtn onClick={() => navigate("contact")} className="greenBg darkColor radius8 semiBold font15">
              צרי קשר
            </CTABtn>
            <CTABtn onClick={() => navigate("home")} className="whiteColor radius8 semiBold font15" style={{ border: "2px solid var(--rose-300)", background: "transparent" }}>
              חזרה לדף הבית
            </CTABtn>
          </CTABtns>
        </div>
      </CTASection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */
const PageHero = styled.section`
  padding: 120px 0 80px;
  direction: rtl;
  @media (max-width: 860px) {
    padding: 100px 0 60px;
    .flexSpaceCenter { flex-direction: column; gap: 40px; }
  }
`;
const HeroText = styled.div`
  width: 55%;
  @media (max-width: 860px) { width: 100%; }
`;
const PageTag = styled.span`
  display: inline-block;
  padding: 5px 14px;
  font-size: 0.813rem;
  font-weight: 600;
`;
const HeroImageBox = styled.div`
  width: 40%;
  @media (max-width: 860px) { width: 100%; }
`;
const HeroImgPlaceholder = styled.div`
  width: 100%;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  background: var(--grad-blush);
  color: var(--rose-600);
  border: 8px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-lift);
  animation: float 7s ease-in-out infinite;
`;
const Section = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
  p { margin-top: 10px; }
`;
const TwoCol = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 70px;
  @media (max-width: 860px) { flex-direction: column; }
`;
const ImageSide = styled.div`
  width: 45%;
  @media (max-width: 860px) { width: 100%; }
`;
const TextSide = styled.div`
  flex: 1;
`;
const MainImgBox = styled.div`
  position: relative;
  padding-bottom: 30px;
`;
const MainImgPlaceholder = styled.div`
  width: 100%;
  height: 420px;
  background: var(--tint-rose);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--rose-600);
`;
const FloatingImg = styled.div`
  position: absolute;
  bottom: -10px;
  left: -20px;
  width: 160px;
  height: 160px;
  background: var(--tint-butter);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ink);
  text-align: center;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(73, 8, 57,0.15);
  @media (max-width: 860px) { display: none; }
`;
const BodyText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
`;
const SmallImgRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 25px;
`;
const MiniImg = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.688rem;
  font-weight: 600;
  color: var(--ink);
  text-align: center;
  padding: 5px;
`;
const JourneyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  @media (max-width: 860px) { grid-template-columns: 1fr; }
`;
const JourneyCard = styled.div`
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
`;
const JourneyImg = styled.div`
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
const JourneyCardBody = styled.div`
  padding: 20px;
`;
const JourneyYear = styled.span`
  display: inline-block;
  padding: 4px 12px;
  font-size: 0.813rem;
  font-weight: 600;
`;
const FullWidthImg = styled.div`
  width: 100%;
  height: 400px;
  @media (max-width: 600px) { height: 240px; }
`;
const FullWidthPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--rose-600) 0%, var(--rose-200) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--rose-700);
`;
const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;
const ValueItem = styled.div`
  text-align: center;
`;
const ValueImg = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
`;
const PhotoItem = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
const CTASection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const CTABtns = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 30px;
  flex-wrap: wrap;
`;
const CTABtn = styled.button`
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
